import React from "react";

// Images imports
import Logo from "../../assets/images/common/logo.jpg";
import { BiPhone } from "react-icons/bi";

// Scss imports
import css from "./Footer.module.scss";

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  return (
    <footer className={css.container}>
      {/*<p>
        © 2021 Контабилита плус · Развијено и дизајнирано од стране Сандре и
        Владе · Сва права задржана
  </p>*/}
      <div className={css.phoneNumbers}>
        <div className={css.phoneNumber}>
          <BiPhone />
          <p>Контабилита плус 064/6386892</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
